import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import { useMeasurement } from '@/hooks/useMeasurement';
import { SPECIFIC_POWER_THRESHOLD } from '@/store/Station/StationStore.utils';

export const useSpecificPowerKPI = () => {
  const { stationStore } = useStores();
  const { t } = useTranslation();
  const { tvalue } = useMeasurement();
  const { specificPower } = get(stationStore, 'currentStation.kpis', {});
  let roundSpecificPower = specificPower;
  if (typeof specificPower === 'number') {
    if (tvalue(specificPower, 'kW/(m^3/min)') >= SPECIFIC_POWER_THRESHOLD) {
      roundSpecificPower = t('N/A');
    } else {
      roundSpecificPower = Number(specificPower?.toFixed(2));
    }
  }

  return roundSpecificPower;
};
